import React from 'react';
import Page from 'Components/Page/Page';
import NotFoundV2 from './components/NotFoundV2/NotFoundV2';
import OlxAutosHeaderLight from '../../olxautos/components/OlxAutosHeaderLight/OlxAutosHeaderLight.APP_TARGET';
import Footer from 'Components/Footer/Footer';

export const NotFoundV2Page = () => {
    const footer = <Footer enableTopMobile={ true } />;
    const header = <OlxAutosHeaderLight />;

    return (
        <Page header={ header } subHeader={ null } footer={ footer }>
            <NotFoundV2 />
        </Page>
    );
};

export default NotFoundV2Page;
